import { NgModule } from 'ng-metadata/core';
import { CartSummaryComponent } from './cart-summary.component';

@NgModule({
  declarations: [CartSummaryComponent],
})
export class CheckoutCartSummaryModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/cart-summary/cart-summary.module.ts